export default class VueMqDdExtension {
  public isMobilePortrait(mq: string): boolean {
    return mq === 'xs'
  }

  public isMobile(mq: string): boolean {
    return ['xs', 'sm'].includes(mq)
  }

  public isTablet(mq: string): boolean {
    return mq === 'md'
  }

  public isTabletOrMobile(mq: string): boolean {
    return this.isMobile(mq) || this.isTablet(mq)
  }

  public isTabletOrDesktop(mq: string): boolean {
    return !this.isMobile(mq)
  }

  public isDesktop(mq: string): boolean {
    return !this.isTabletOrMobile(mq)
  }

  public isLargeDesktop(mq: string): boolean {
    return mq === 'xl'
  }

  public isGoNativeiOSMobileApp(mq: string): boolean {
    const userAgent = window.navigator.userAgent
    return (
      this.isMobile(mq) &&
      this.isGoNativeApp() &&
      userAgent.toLowerCase().indexOf('gonativeios') > -1
    )
  }

  public isGoNativeApp(): boolean {
    const userAgent = window.navigator.userAgent
    return userAgent.indexOf('gonative') > -1
  }
}
